import p from "./index971.js";
import a from "./index972.js";
import i from "./index973.js";
import h from "./index974.js";
import s from "./index975.js";
function t(e) {
  var o = -1, l = e == null ? 0 : e.length;
  for (this.clear(); ++o < l; ) {
    var r = e[o];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = i;
t.prototype.has = h;
t.prototype.set = s;
export {
  t as default
};
